var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Banner',{attrs:{"data":_vm.dataBanner}}),_c('JobOpenings',{attrs:{"jobs":_vm.jobs}}),_c('KeyBenefit'),_c('Message'),_c('div',{staticClass:"welcomeProject"},[_c('Welcome',{attrs:{"data":_vm.welcome}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }